import React from 'react';
import profileService from '../../services/profileService'
import { toast } from 'react-toastify';
import sessionService from '../../services/sessionService';

export default class ChangePassword extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            password: '',
            newPassword: '',
            confirmPassword: ''
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showEditPassword = this.showEditPassword.bind(this);
        this.hideEditPassword = this.hideEditPassword.bind(this);
        this.options = {
            autoClose: 3000,
            hideProgressBar: true,
        };
    }
    showEditPassword() {
        this.setState({
            edit: true
        })
    }
    hideEditPassword() {
        this.setState({
            edit: false
        })
    }
    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleSubmit = event => {
        event.preventDefault();
        if (this.validateForm()) {
            profileService.changePassword(this.state)
                .then(response => {
                    if (sessionService.isAuth()) {
                        this.setState({
                            password: '',
                            newPassword: '',
                            confirmPassword: '',
                        });
                        toast.success("Password is successfully updated!", this.options)
                        this.setState({
                            edit: false
                        })
                    }
                }).catch(error => {
                    toast.error(error.response, this.options)
                });
        }

    }

    validateForm() {
        return this.state.password && this.state.newPassword && this.state.confirmPassword
    }

    render() {
        const { password, newPassword, confirmPassword, edit } = this.state;
        return (
            <div className="subtitle-border-bottom">
                <ul>
                    {!edit ? <li className="profil-change-pass">
                        <h6 className="grey">Password:</h6>
                        <span className="lightblue">&#9679; &#9679; &#9679; &#9679; &#9679; &#9679; &#9679; &#9679;<span className="link-look pull-right" onClick={this.showEditPassword}>Edit</span> </span>
                    </li> :
                        <div className="change-pass-profil">
                            <h6 className="mt-3 mb-3 blue"> Password <span className="link-look pull-right" onClick={this.hideEditPassword}>Close</span></h6>
                            <hr />
                            <form onSubmit={this.handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="password">Old password:</label>
                                    <input id='password' className="form-control" type="password" name="password" value={password} onChange={this.handleChange} />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="newPassword">New password:</label>
                                    <input id='newPassword' className="form-control" type="password" name="newPassword" value={newPassword} onChange={this.handleChange} />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="confirmPassword">Confirm new password:</label>
                                    <input id='confirmPassword' className="form-control" type="password" name="confirmPassword" value={confirmPassword} onChange={this.handleChange} />
                                </div>
                                <div className="clearfix">
                                    <button className="btn btn-lightblue  pull-right">Change password</button>
                                </div>
                            </form>
                        </div>}
                </ul>
            </div>

        )
    }
};


// WEBPACK FOOTER //
// ./src/components/profile/changePassword.js